"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCleanupQueryParams = exports.useScrollDirection = exports.Scroll = void 0;
const react_1 = require("react");
const throttle_1 = __importDefault(require("lodash/throttle"));
const web_env_1 = require("@snapchat/web-env");
/**
 * All these params are needed for a redirect in case we deep link to the app.
 * However, once we hit the web page, we are sure that we haven't deep linked and the query params are unnecessary.
 */
const UNUSED_QUERY_PARAMS_POST_REDIRECT = [
    "web_client_id",
    "trace_id",
    // AppsFlyer params
    "pid",
    "c",
    "af_dp",
    "af_web_dp",
    "af_ios_url",
    "af_android_url",
    "af_js_web",
];
var Scroll;
(function (Scroll) {
    Scroll[Scroll["IDLE"] = 0] = "IDLE";
    Scroll[Scroll["DOWN"] = 1] = "DOWN";
    Scroll[Scroll["UP"] = 2] = "UP";
    Scroll[Scroll["REACH_BOTTOM"] = 3] = "REACH_BOTTOM";
})(Scroll = exports.Scroll || (exports.Scroll = {}));
function isScrolledToBottom(scrollElement) {
    if (scrollElement) {
        return scrollElement.scrollTop + scrollElement.clientHeight >= scrollElement.scrollHeight - 1;
    }
    const documentObj = (0, web_env_1.getDocument)();
    if (documentObj) {
        const winScroll = documentObj.body.scrollTop || documentObj.documentElement.scrollTop;
        const height = documentObj.documentElement.scrollHeight - documentObj.documentElement.clientHeight;
        // The tolerance is set to 0.001 which means that if the difference between value
        // and 1.0 is less than 0.001, the function will return true.
        // This is an extra calibration since sometimes, winScroll / height is not equal to 1.
        const tolerance = 0.001;
        return Math.abs(winScroll / height - 1.0) < tolerance;
    }
    else {
        return true;
    }
}
/**
 * a custom hook that returns scroll direction
 */
function useScrollDirection(mobilePageContainerRef) {
    const [scrollDirection, setScrollDirection] = (0, react_1.useState)(Scroll.IDLE);
    const pageContainer = mobilePageContainerRef?.current ?? undefined;
    (0, react_1.useEffect)(() => {
        const scrollElement = pageContainer || (0, web_env_1.getWindow)();
        let lastScrollY = pageContainer?.scrollTop || (0, web_env_1.getWindow)()?.pageYOffset || 0;
        const updateScrollDirection = (0, throttle_1.default)(() => {
            const scrollY = pageContainer?.scrollTop || (0, web_env_1.getWindow)()?.pageYOffset || 0;
            let direction = scrollY > lastScrollY ? Scroll.DOWN : Scroll.UP;
            if (isScrolledToBottom(pageContainer)) {
                direction = Scroll.REACH_BOTTOM;
                setScrollDirection(direction);
            }
            else if (direction !== scrollDirection &&
                (scrollY - lastScrollY > 10 || scrollY - lastScrollY < -10)) {
                setScrollDirection(direction);
            }
            lastScrollY = scrollY > 0 ? scrollY : 0;
        }, 400);
        scrollElement?.addEventListener("scroll", updateScrollDirection); // add event listener
        return () => {
            scrollElement?.removeEventListener("scroll", updateScrollDirection); // clean up
        };
    }, [pageContainer, scrollDirection]);
    return scrollDirection;
}
exports.useScrollDirection = useScrollDirection;
/**
 * Cleanup unused query params from the URL after we are sure that the user hasn't deep linked.
 */
function useCleanupQueryParams() {
    (0, react_1.useEffect)(() => {
        const windowRef = (0, web_env_1.getWindow)();
        if (windowRef) {
            const path = windowRef.location.pathname;
            const queryParamMap = new URLSearchParams(windowRef.location.search);
            for (const unusedQueryParam of UNUSED_QUERY_PARAMS_POST_REDIRECT) {
                if (queryParamMap.has(unusedQueryParam)) {
                    queryParamMap.delete(unusedQueryParam);
                }
            }
            const queryParamMapSize = Array.from(queryParamMap).length;
            const queryParamString = queryParamMapSize > 0 ? "?" + queryParamMap.toString() : "";
            history.replaceState(null, "", path + queryParamString);
        }
    }, []);
}
exports.useCleanupQueryParams = useCleanupQueryParams;
//# sourceMappingURL=hooks.js.map